import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { Box } from '@mantine/core';
import { useEffect, useState } from 'react';

import { getCurrentUserProfile } from '@/api/authApi';
import { ContentSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton';
import { useLanguage } from '@/i18n/LanguageContext';
import { getToken } from '@/utils/cookies';

const AuthGuard = () => {
  const location = useLocation();
  const token = getToken();
  const { setLanguageFromServer } = useLanguage();
  const [profileReady, setProfileReady] = useState(false);

  useEffect(() => {
    let active = true;
    if (!token) {
      setProfileReady(true);
      return () => { active = false; };
    }

    setProfileReady(false);
    getCurrentUserProfile()
      .then((profile) => {
        if (!active) return;
        setLanguageFromServer(profile.language);
        localStorage.setItem('DemoLogin', profile.username);
        localStorage.setItem('company_name', profile.company_name);
        localStorage.setItem('user_role', profile.role);
        if (profile.operator_name) {
          localStorage.setItem('operator_name', profile.operator_name);
        } else {
          localStorage.removeItem('operator_name');
        }
      })
      .catch(() => undefined)
      .finally(() => {
        if (active) setProfileReady(true);
      });

    return () => { active = false; };
  }, [setLanguageFromServer, token]);
  
  // Check if user has valid token
  if (token) {
    if (!profileReady) {
      return <Box p="md"><ContentSkeleton /></Box>;
    }
    return <Outlet />;
  }
  
  return <Navigate to='/authorization' state={{ from: location }} replace />;
}

export default AuthGuard;
